import React from 'react'
import Lottie from 'lottie-react-web'
import animation from './data.json'
import MetaTags from 'components/elements/meta/metaTags'
import { Columns, Header } from 'components/elements'
import './BikeListing.css'

const BikeWasDeleted =({ inactiveBikeDetails }) =>  {
  return (
    <div>
      {/* set canonical and  title tag; if bike state is inactive/deleted */}
      {inactiveBikeDetails?.status == false &&
        <MetaTags
          title={
            inactiveBikeDetails.bike_year.toString() +
            ' ' +
            inactiveBikeDetails.bike_make +
            ' ' +
            inactiveBikeDetails.bike_model +
            ' Motorcycle Rental in ' +
            inactiveBikeDetails.bike_location.location_city +
            ', ' +
            inactiveBikeDetails.bike_location.location_region_abbr +
            ' ' +
            inactiveBikeDetails.bikeID +
            ' '
          }
          description={
            inactiveBikeDetails.bike_year.toString() +
            ' ' +
            inactiveBikeDetails.bike_make +
            ' ' +
            inactiveBikeDetails.bike_model +
            ' motorcycle rental in ' +
            inactiveBikeDetails.bike_location.location_city +
            ', ' +
            inactiveBikeDetails.bike_location.location_region_abbr +
            '. ' +
            inactiveBikeDetails.bike_description
          }
          facebookDescription={inactiveBikeDetails.bike_description}
          url={inactiveBikeDetails.bike_url}
          type="product"
          setPrerenderStatusCode={true}
        />
      }
      {!inactiveBikeDetails &&
        <MetaTags setPrerenderStatusCode={true} type="product"/>
      }
      <Columns className="is-centered bike-image">
        <Columns.Column size={4}>
          <Lottie
            options={{
              animationData: animation,
              assetsPath: '/static/images/animations/reservationsEmpty/',
              loop: false,
            }}
          />
        </Columns.Column>
      </Columns>
      <Columns className="has-text-centered">
        <Columns.Column size={12}>
          <Header
            className="has-text-weight-extra-bold main-oops-header"
            size={3}
            renderas="h2"
          >
            Oops. Looks like this motorcycle is no longer available.
          </Header>
          <Header subtitle size={5} renderas="h2">
            The adventure of a lifetime awaits you.
          </Header>
          <a
            color="primary"
            size="medium"
            href="/"
            className="button is-primary is-medium has-text-weight-extra-bold"
          >
            Search Available Motorcycles
          </a>
        </Columns.Column>
      </Columns>
    </div>
  )
}

export default BikeWasDeleted
